export const renderExpenseCard = (
  expense,
  detectExpenseType,
  expensePresets,
  formatDateToDDMMYYYY,
  handleViewJustificatif
) => {
    const specificData = expense.donnees_specifiques || {};
    const expenseType = expense.type_depense || detectExpenseType(expense);
    const preset = expensePresets[expenseType] || expensePresets.other;

    // Utiliser le montant total incluant la TVA depuis les données spécifiques
    const totalAmount = specificData.montantAvecTva || expense.montant || expense.amount;

    // Formater le montant au format français
    const formattedAmount = parseFloat(totalAmount).toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    let justificatifs = [];
    if (expense.justificatif) {
      try {
        justificatifs = typeof expense.justificatif === 'string'
          ? JSON.parse(expense.justificatif)
          : expense.justificatif;
      } catch {
        justificatifs = [];
      }
    }

    return (
      <div className="expense-card">
        <div className="expense-header">
          <h3>{preset.title}</h3>
          <span className="expense-amount">{formattedAmount} €</span>
        </div>
        <div className="expense-details">
          <p>{expense.description || 'Aucune description'}</p>
          <p><strong>Date:</strong> {formatDateToDDMMYYYY(expense.date_depense)}</p>
          {preset.fields.map(field => {
            let displayValue = specificData[field.id] || 'Non renseigné';
            
            // Si c'est un champ de type date, le formater
            if (field.type === 'date' && displayValue !== 'Non renseigné') {
              displayValue = formatDateToDDMMYYYY(displayValue);
            }
            
            return (
              <p key={field.id}>
                <strong>{field.label}:</strong> {displayValue}
              </p>
            );
          })}
          {justificatifs.length > 0 && (
            <div className="justificatifs-container">
              {justificatifs.map((justificatif, idx) => {
                // Gérer les deux formats : string (ancien) et objet {name, path} (nouveau)
                const filePath = typeof justificatif === 'string' ? justificatif : justificatif.path;
                
                return (
                  <button
                    key={idx}
                    type="button"
                    className="view-justificatif-button"
                    onClick={e => {
                      e.stopPropagation();
                      handleViewJustificatif(filePath);
                    }}
                  >
                    <i className="fa-solid fa-eye"></i> Voir le justificatif {idx + 1}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  };
